import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
export default {
  name: 'GenericFaq',
  components: {
    SimpleParagraph: SimpleParagraph
  },
  props: {
    question: {
      type: String,
      required: true
    },
    answer: {
      type: Array,
      required: true
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    faqHeight: function faqHeight() {
      if (!this.open) return 0;
      return "".concat(this.$refs.answer.$el.scrollHeight, "px");
    }
  }
};